import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function priceValidator(
  priceKey: string = 'priceControl',
  basisPriceKey: string = 'basisPriceControl'
): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const price = control.get(priceKey)?.value;
    const basisPriceGroup = control.get(basisPriceKey);

    const basisPoints = basisPriceGroup?.get('basisPoints')?.value;
    const month = basisPriceGroup?.get('month')?.value;
    const code = basisPriceGroup?.get('product_code')?.value;
    const year = basisPriceGroup?.get('year')?.value;

    // Check if price is provided
    const isPriceFilled = !!price;

    // Check if all fields in basisPrice group are filled
    const isBasisPriceFilled = basisPoints && month && code && year;

    // Return null if the form is valid (either price or basisPrice group must be filled)
    if (isPriceFilled || isBasisPriceFilled) {
      return null;
    }
    // Return validation error if neither is fully filled
    return { priceRequired: true };
  };
}
